export default {
    SET_MILESTONES(state, array) {
        state.milestones = array;
    },
}
